import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'
import { ListingResponse } from '~in-app/types/api.dto'

import { SiteListQuery, SitesRoot } from './types'

export const fetchSiteList = async (params?: { abortCtrl?: AbortController | AbortSignal, query?: SiteListQuery }) => {
  return wretchClient
    .url('/admin/1.0/sites')
    .signal(params?.abortCtrl)
    .query(params?.query || {})
    .get()
    .json<ListingResponse<SitesRoot>>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
